import { checkPermissions } from '@topconagriculture/casbin-react';
import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
export const Router = ({ routes, redirects, match, switchProps }) => {
    const [routesWithPermissions, setRoutesWithPermissions] = React.useState([]);
    const [redirectWithPermissions, setRedirectWithPermissions] = React.useState();
    React.useEffect(() => {
        let isMounted = true;
        const checkRoutes = async () => {
            const hasPermissions = await Promise.all(routes.map(async ({ permission }) => !permission || (await checkPermissions(permission))));
            if (isMounted) {
                setRoutesWithPermissions(routes.filter((_, i) => hasPermissions[i]));
            }
        };
        checkRoutes();
        return () => {
            isMounted = false;
        };
    }, [routes]);
    React.useEffect(() => {
        let isMounted = true;
        const checkRedirect = async () => {
            if (!redirects)
                return;
            const hasPermissions = await Promise.all(redirects.map(async ({ permission }) => !permission || (await checkPermissions(permission))));
            const redirect = redirects.find((_, i) => hasPermissions[i]);
            if (isMounted && redirect) {
                setRedirectWithPermissions(redirect);
            }
        };
        checkRedirect();
        return () => {
            isMounted = false;
        };
    }, [redirects]);
    if (!routesWithPermissions.length)
        return null;
    const buildKey = (route) => (match ? match.url : '') + route.path;
    const buildPath = (route) => (match ? match.url : '') + route.path;
    return (React.createElement(Switch, Object.assign({}, switchProps),
        routesWithPermissions.map((route, i) => (React.createElement(Route, Object.assign({}, route, { key: route.path ? buildKey(route) : i, path: route.path ? buildPath(route) : undefined })))),
        redirectWithPermissions && React.createElement(Redirect, Object.assign({}, redirectWithPermissions))));
};
Router.displayName = 'Router';
//# sourceMappingURL=Router.js.map